import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBlockShift(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M2.334 5h11.333m-8.5 2.833v-.007m0 3.007v-.007M8 7.833v-.007m0 3.007v-.007m2.834-2.993v-.007m-5.5.007a.167.167 0 1 1-.334 0 .167.167 0 0 1 .333 0m0 3a.167.167 0 1 1-.334 0 .167.167 0 0 1 .333 0m2.833-3a.167.167 0 1 1-.334 0 .167.167 0 0 1 .334 0m0 3a.167.167 0 1 1-.333 0 .167.167 0 0 1 .333 0m2.833-3a.167.167 0 1 1-.333 0 .167.167 0 0 1 .333 0m-6.667 5.833h7.334a2 2 0 0 0 2-2V4.333a2 2 0 0 0-2-2H4.334a2 2 0 0 0-2 2v7.333a2 2 0 0 0 2 2"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBlockShift);
export default ForwardRef;
